import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useDrawer } from 'src/hooks/useDrawer';

export const UnauthorizedButtons = () => {
  const { t } = useTranslation();
  const { startRegistration, startLogin } = useAuthFlow();
  const { closeDrawer } = useDrawer();

  return (
    <>
      <Button
        title={`${t('general.signUp')}`}
        mode="button-primary"
        onClick={() => {
          closeDrawer();
          startRegistration();
        }}>
        {t('general.signUp')}
      </Button>
      <Button
        title={`${t('general.logIn')}`}
        mode="button-tertiary"
        onClick={() => {
          closeDrawer();
          startLogin({ defaultFlow: false });
        }}>
        {t('general.logIn')}
      </Button>
    </>
  );
};
